import React from 'react';

class ListItem extends React.Component {
  componentDidMount() {
    if (this.props.item.active) {
      const options = {
        behavior: 'instant',
        block: 'center',
        inline: 'center',
      };
      if (this.node) {
        this.node.scrollIntoView(options);
      }
    }
  }

  render() {
    const className = this.props.item.active ? 'popup-list-item active' : 'popup-list-item';
    const itemName = this.props.item.name;
    return (
      <div
        ref={(node) => {
          this.node = node;
        }}
        className={className}
        role="button"
        tabIndex="0"
        key={this.props.item.id}
        onClick={() => this.props.onClickHandler(this.props.item)}
      >
        {itemName}
      </div>
    );
  }
}

export default ListItem;
